import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface GetUserMetadataParameters extends NextApiParams {}

export const getUserMetadata = withNextApi<
  GetUserMetadataResponse,
  GetUserMetadataParameters
>("/metadata/GetUserMetadata", { method: "GET" });

export interface GetUserMetadataResponse extends BackendResponse {
  item: UserMetadata;
}

export interface UserMetadata {
  lastSeenInPwa: string;
  recentProfileVisits?: string | null;
  /** The session ID from the current auth cookie — set by the server, not stored in the DB. */
  currentSessionId?: string | null;
  /** Optional JSON for other preferences. */
  settings?: string | null;
}

export interface RecentProfileVisit {
  concernId: number;
  candidateId: number | null;
  sessionId: string | null;
}

/** Parses {@link UserMetadata.recentProfileVisits} into entries. */
export function parseRecentProfileVisits(
  csv: string | null | undefined
): RecentProfileVisit[] {
  if (!csv || !csv.trim()) return [];

  return csv
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean)
    .map((part): RecentProfileVisit | null => {
      const [concernStr, candidateStr, sessionStr] = part.split(":");
      const concernId = parseInt(concernStr, 10);
      if (!Number.isFinite(concernId)) return null;

      const candidateId =
        candidateStr != null && candidateStr !== "" ? parseInt(candidateStr, 10) : NaN;
        
      return {
        concernId,
        candidateId: Number.isFinite(candidateId) ? candidateId : null,
        sessionId: sessionStr != null && sessionStr !== "" ? sessionStr : null,
      };
    })
    .filter((e): e is RecentProfileVisit => e != null);
}
